import { Chat, ChatList } from '../Types';
import requestClient from '../components/Utility/RequestClient';

export const chatService = {
    getChat: async (chatId: any): Promise<any> => {
        return requestClient.get<Chat>(`/chat/show/${chatId}`);
    },

    updateDLP: async (chatId: any, data: any): Promise<any> => {
        return requestClient.post<Chat>(`/chat/update/${chatId}`, data);
    },

    uploadFile: async (data: any): Promise<any> => {
        return requestClient.post(`/chat/uploadfile`, data);
    },

    uploadImage: async (data: any): Promise<any> => {
        return requestClient.post(`/chat/uploadimage`, data);
    },

    getChatList: async (): Promise<any> => {
        return requestClient.get<{ chats: ChatList[] }>(`/chat/list`);
    },

    deleteChat: async (identifier: any): Promise<any> => {
        return requestClient.delete(`/chat/delete/${identifier}`);
    },

    updateChat: async (identifier: any, chatTitle: any): Promise<any> => {
        return requestClient.post(`/chat/update/${identifier}`, { title: chatTitle });
    },

    getBaseAndLastUpdatedPrompt: async (): Promise<any> => {
        return requestClient.get(`/prompts/getbaseandlastusedprompts`);
    },

    createChat: async (promptIdentifier: string, dlpActive: boolean): Promise<any> => {
        return requestClient.post(`/chat/create`, {
            prompt: promptIdentifier,
            isDlpActive: dlpActive,
        });
    },

    checkDlp: async (text: string, identifier: string) => {
        return await requestClient.post('/dlp/check', {
            text,
            identifier,
        });
    },

    getChatListByPage: async (
        page: number,
        itemsPerPage: number,
    ): Promise<{ data: { data: ChatList[]; total: number } }> => {
        return requestClient.get(`/chat/list`, {
            params: {
                page,
                itemsPerPage,
            },
        });
    },
};
